export default "__VITE_ASSET__75b43a6c__"